<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col order-1 order-lg-2">
        <div class="row mt-3" v-if="live_start_date && showDate && isFutureDate">
          <div class="col-12 text-center">
            <h5>{{ 'This event starts in' | translate }}:</h5>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mx-auto">
            <CountdownTime :date="date"></CountdownTime>
          </div>
        </div>
        <div
          class="row my-3"
          v-if="course.live_show_additional_message"
        >
          <div
            class="col-12 col-md-6 col-lg-4 mx-auto"
            v-if="course.live_message"
            v-html="course.live_message.html"
          ></div>
          <div
            class="col-12"
            v-html="course.live_additional_html"
          ></div>
        </div>
        <div class="row mt-3" v-if="hasAccess">
          <div class="col-lg-9 mx-auto" v-if="live_video_embed_url">
            <div class="ratio ratio-16x9">
              <iframe
                :src="live_video_embed_url"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div
            class="col-lg-3"
            v-if="live_chat_embed_url"
            style="min-height: 400px"
          >
            <iframe
              :src="live_chat_embed_url"
              width="100%"
              height="100%"
              frameborder="0"
            ></iframe>
          </div>
        </div>
        <div v-else class="row mt-3">
          <div class="col-12 text-center">
            <a
              class="btn btn-primary m-3"
              :href="`/${$route.params.course}/checkout`"
            >
              {{ 'Enroll' | translate }}
            </a>
            <router-link
              v-if="!isAuthenticated"
              :to="`/${$route.params.course}/watch/login`"
            >
              {{ 'Sign in' | translate }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <PasswordLogin ref="passwordLogin"></PasswordLogin>
  </div>
</template>

<script>
import PasswordLogin from './../components/PasswordLogin'
import _ from 'lodash'
import dayjs from 'dayjs'
import CountdownTime from './../../web-components/CountdownTime'

export default {
  components: {
    PasswordLogin,
    CountdownTime,
  },
  data() {
    return {
      showDate: true,
    }
  },
  mounted() {
    this.deployAt(this.live_start_date, this.setShowDate)
  },
  methods: {
    setShowDate() {
      this.showDate = false
    },
    deployAt(date, action) {
      if (_.isNull(date)) {
        return false
      }
      
      if (!date._isAMomentObject) {
        date = dayjs(date)
      }

      let now = dayjs()
      let difference = now.diff(date)

      if (difference < 0) {
        setTimeout(action, Math.abs(difference))
      } else if (difference > 0) {
        action()
      }
    },
    loginModal() {
      this.$refs.passwordLogin.open()
    },
    back() {
      return this.$api.back(this.$route.params.course)
    },
  },
  computed: {
    loading() {
      let courseId = _.get(this.course, 'id', false)
      if (courseId) {
        return false
      }
      return true
    },
    date() {
      return dayjs(this.live_start_date)
    },
    isFutureDate() {
      return dayjs(this.live_start_date).isAfter(dayjs())
    },
    course() {
      return this.$store.state.course
    },
    live_start_date() {
      return _.get(this.course, 'live_start_date', null)
    },
    live_video_embed_url() {
      return _.get(this.course, 'settings.live_video_embed_url', null)
    },
    live_chat_embed_url() {
      return _.get(this.course, 'settings.live_chat_embed_url', null)
    },
    hasAccess() {
      return this.$store.state.hasAccess
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
  },
}
</script>
